
export default {
  data() {
    return {
      newBranding: process.env.VUE_APP_NEW_BRANDING === "true"
    }
  }
}
